import React, { useState } from 'react';
import { Car, Ship, Plane, ChevronDown } from 'lucide-react';
import { useStore } from '../store';

const OPTIONS = [
  { id: 'suv', label: 'SUV', icon: Car },
  { id: 'boat', label: 'Research Boat', icon: Ship },
  { id: 'helicopter', label: 'Helicopter', icon: Plane },
];

// Inline vehicle picker that lives in the top-right HUD row. Dropdown opens
// downward as an overlay so it never pushes the layout or covers the zone title.
export default function VehicleSelector() {
  const mode = useStore((s) => s.mode);
  const setMode = useStore((s) => s.setMode);
  const [open, setOpen] = useState(false);
  const current = OPTIONS.find((o) => o.id === mode) || OPTIONS[0];
  const Cur = current.icon;

  const pick = (id) => { setMode(id); setOpen(false); };

  return (
    <div data-testid="vehicle-selector" className="relative pointer-events-auto">
      <button
        data-testid="vehicle-toggle"
        onClick={() => setOpen((v) => !v)}
        title="Select Vehicle"
        className="flex items-center gap-2 px-4 py-3 rounded-full glass-gold text-gold hover:bg-gold hover:text-black transition-colors duration-300 uppercase tracking-widest text-[10px] font-bold"
      >
        <Cur className="w-5 h-5 shrink-0" strokeWidth={1.8} />
        Vehicle
        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 flex flex-col gap-2 animate-hud-in z-[95]">
          {OPTIONS.map((o) => {
            const Icon = o.icon;
            const active = o.id === mode;
            return (
              <button
                key={o.id}
                data-testid={`vehicle-${o.id}-btn`}
                onClick={() => pick(o.id)}
                className={`flex items-center gap-3 pl-3.5 pr-6 py-3 rounded-full whitespace-nowrap transition-colors duration-300 ${
                  active ? 'glass-gold text-gold' : 'glass text-white/75 hover:text-gold'
                }`}
              >
                <Icon className="w-5 h-5 shrink-0" strokeWidth={active ? 2 : 1.5} />
                <span className="font-serif text-base font-semibold">{o.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
